// extracted by mini-css-extract-plugin
export default {"setting-dropdown-item":"SettingDropdown_setting-dropdown-item__VaVbN"};